import React, { Component } from "react";
import { Chip } from '@material-ui/core';
import {calculateDayVelocityColour} from '../services/status-colours';

class StatusCard extends Component {
    render() {

        const chipColour = calculateDayVelocityColour(this.props.value);

        return (
            <Chip color="primary" style={{backgroundColor: chipColour}} label={this.props.caption}></Chip>
        );
    }
}

export default StatusCard;